import { create } from 'zustand';

interface NavigationGuardState {
  /**
   * When set, MainLayout's sidebar menu routes a click through this instead
   * of navigating directly — see usePageNavigationGuard. Called with the
   * route the candidate tried to go to; the guard decides what happens next
   * (e.g. confirm, then navigate itself once confirmed).
   */
  guardNavigation: ((route: string) => void) | null;
  setNavigationGuard: (guard: (route: string) => void) => void;
  clearNavigationGuard: () => void;
}

export const useNavigationGuardStore = create<NavigationGuardState>((set) => ({
  guardNavigation: null,
  setNavigationGuard: (guardNavigation) => set({ guardNavigation }),
  clearNavigationGuard: () => set({ guardNavigation: null }),
}));

export default useNavigationGuardStore;
